import { Component, OnInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';
import { CustomFormUtilsService } from './../../custom-form-utils.service';
import { CustomEventService } from './customEventService';


/**
 * Componente que renderiza el editor de Eventos de un customform
 */
@Component({
  template: `
  <nb-card-body>
    <div class="row">
      <div class="col-12" >
        <div class="form-group">
            <input class="col-11" type="text" nbInput fullWidth (keyup)="actualizaTraduccion()" [(ngModel)]="evento"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" >
        <div class="form-group">
          <div>
            <label class="label">{{resultado}}</label>
          </div>
        </div>
      </div>
    </div>

  </nb-card-body>
  `,
})

export class EventsComponent extends DefaultEditor implements OnInit {
  resultado: String;
  evento:String;
  listaIdElem:any;
  constructor(
    private customFormUtilsService:CustomFormUtilsService,
    private customeventservice: CustomEventService

  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    //Obtenemos el valor de la fila y se lo asignamos a la variable evento
    this.evento = this.cell.newValue;

    //Obtenemos la lista de campos del formulario
    this.listaIdElem = await this.customFormUtilsService.getFormFieldList();
    this.actualizaTraduccion();
  }

  changeEvents(){
    //Esto sería para guardar
    this.cell.newValue = this.evento;
  }

  public async actualizaTraduccion(){
    let vResul = await this.customeventservice.validaExpresion(this.evento);
    this.resultado = vResul.vTraduccion
    if (vResul.vExprValida == true){
      this.changeEvents()
    }
  }
}
